import { Component, OnInit } from '@angular/core';
import { BookingType, CalendarMode } from '../../widgets-module/components/booking-calendar/booking-calendar.component';
import { loadFareHarborScript } from '../../../fareharbor-load-script';

@Component({
  selector: 'app-booking-and-rates',
  templateUrl: './booking-and-rates.component.html',
  styleUrls: ['./booking-and-rates.component.css']
})
export class BookingAndRatesComponent implements OnInit {

  // Calendar Variables
  bookingType = BookingType.All;
  calendarModes: CalendarMode[] = [
    { priceInDollars: 'N/A', selectorText: '1 or 2 people', calendarId: '295177' },
    { priceInDollars: 'N/A', selectorText: '3+ people', calendarId: '298053' }
  ];
  loadAPI: Promise<any>;

  constructor() {
    this.loadAPI = new Promise((resolve) => {
      loadFareHarborScript();
      resolve(true);
    });
  }

  ngOnInit() {
  }
}
